module.exports = __webpack_public_path__ + "img/logo_text.e7ce09f8.svg";